import {
  Component,
  ElementRef,
  HostListener,
  Output,
  ViewChild,
  EventEmitter,
  Input,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {IMessengers} from 'src/app/interfaces/messengers.interface';

@Component({
  selector: 'app-messengers',
  templateUrl: './messengers.component.html',
  styleUrls: ['./messengers.component.scss'],
})
export class MessengersComponent {
  public visibleContent = false;
  isTelegram = false;

  @ViewChild('messengers') messengers!: ElementRef; // main wraper of this component
  @Output() messengersChecked = new EventEmitter();
  @Output() removePhone = new EventEmitter();
  @Input() public personalTab = false;
  @Input() set phoneData(value: IMessengers) {
    this.form.setValue({
      phoneNumber: value.phoneNumber,
      isTelegram: value.isTelegram,
      isViber: value.isViber,
      isWhatsApp: value.isWhatsApp,
    });
  }
  public phoneMask: string = '+#00000000000';
  phonePatterns = {
    '#': {pattern: new RegExp('[1-9]')},
    '0': {pattern: new RegExp('[0-9]')},
  };

  @Input() public editMode = true;
  form!: UntypedFormGroup;

  constructor(private _fb: UntypedFormBuilder) {
    this.form = this._fb.group({
      phoneNumber: new UntypedFormControl('', [Validators.required]),
      isTelegram: new UntypedFormControl(false),
      isViber: new UntypedFormControl(false),
      isWhatsApp: new UntypedFormControl(false),
    });
  }

  @HostListener('document:click', ['$event'])
  clickOut(event: MouseEvent) {
    if (this.visibleContent)
      this.visibleContent = !!this.messengers.nativeElement.contains(
        event.target
      );
  }

  showItems(): void {
    this.visibleContent = !this.visibleContent;
  }

  onCheckChange() {
    this.messengersChecked.emit({
      dirty: this.form.dirty,
      value: this.form.value,
    });
  }
}
